import { TAB_ACTION } from '../actions/types';

const initialState = {
  expandSavedGiggers: false,
  expandHiredGiggers: false,
  expandPurchasedContacts: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case TAB_ACTION:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
